<template>
    <div class="c-fill-height">
        <v-container fluid grid-list-xl class="c-container c-container__light">
            <h5 class="headline c-mb-4">Einstellungen</h5>


            <v-form class="c-form" ref="form" v-model="valid" lazy-validation>
                <v-text-field
                        v-model="account.name"
                        label="Name"
                        required
                        class="c-mb-5">
                </v-text-field>

                <v-text-field
                        v-model="account.phone"
                        label="Telefonnummer"
                        required
                        readonly
                ></v-text-field>

                <v-text-field
                        v-model="account.email"
                        type="email"
                        label="Email"
                        required
                ></v-text-field>

                <v-text-field
                        v-model="account.password"
                        label="Passwort"
                        type="password"
                        required
                ></v-text-field>
            </v-form>

        </v-container>
        <div class="c-form-footer">
            <v-btn large class="shrink" flat color="secondary" @click="logout">
                Logout
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn large class="shrink" flat>
                Abbrechen
            </v-btn>
            <v-btn large class="shrink" color="secondary">
                Speichern
            </v-btn>
        </div>
    </div>
</template>

<script>
import Amplify from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'

export default {
  name: 'SettingsView',
  data () {
    return {
      editMode: false,
      valid: false,
      account: {
        name: 'Maya Hess',
        phone: '(123) 555-5555',
        email: 'abc@abcd.com',
        password: 'secret'
      }
    }
  },
  computed: {},
  created () {},
  methods: {
    async logout () {
      (await Auth.currentAuthenticatedUser()).clearCachedTokens()
      await Auth.signOut()
      // Reset any Amplify config.
      Amplify._config = {}
      this.$router.go()
    },
  }
}
</script>
